import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import TableauDash from "../../components/commonComponents/TableauDashboard/TableauDash";
import RetailAnalyticsFilter from "./Filters/RetailAnalyticsFilter";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../api_calls/userManagement";
import { useDispatch, useSelector } from "react-redux";
import { resetBrandReportView, storeListOptionsForFilter, findStoreIds, findEmbeddableId } from "../../api_calls/utils";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import { deleteItems } from "../../Store/actions";
import { resolveEmbeddableNumberRoot } from "../../api_calls/retailerSelection";
import platformConfig from "../../platformConfig";

const HeatMap = () => {
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});
  const dispatchAction = useDispatch();
  const numberRoot = resolveEmbeddableNumberRoot(userInfo.root_company_id);
  const dashboardVariables = () => {
    let heatmapVariables = {};

    if (typeof userStateDate.embedded_heatmap_stores !== "undefined" && typeof userStateDate.embedded_heatmap_stores.store_ids !== "undefined" && userStateDate.embedded_heatmap_stores.store_ids.length !== 0) {
      heatmapVariables = {
        ...heatmapVariables,
        Stores: userStateDate.embedded_heatmap_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_heatmap_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_heatmap_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      heatmapVariables = {
        ...heatmapVariables,
        Date: {
          from: userStateDate?.embedded_heatmap_date.from,
          to: endDate
        },
      }
    }

    return heatmapVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    resetBrandReportView();
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);
  return (
    <StyledMainBox component="main">
      {/* ------------- filters -------------- */}
      <RetailAnalyticsFilter
        reduxKeyForStore="embedded_heatmap_stores"
        reduxKeyForDate="embedded_heatmap_date"
        singleStore={true}
      />
      <Box height={1} />
      {/* ----------- tableau dashboard ---------- */}
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" &&
          typeof userStateDate.store_dates !== "undefined" &&
          typeof userStateDate.embedded_heatmap_stores !== "undefined" && (
          <Dashboard
            key={numberRoot}
            embedDashboardId={findEmbeddableId("retail_analytics", "heatmap")}
            variables={dashboardVariables()}
            filterConfig={{
              "number_root": numberRoot,
            }} />
        )}
      </Grid>
    </StyledMainBox>
  );
};
// remove array if all user types are allowed. if only some are allowed, add them like below
export default AccessControl(HeatMap, ["analytics_can_view"], platformConfig.retailAnalyticsAvailableFor, ["retail_analytics_section", "heatmap"]);
